import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
  InventoryCountWithInventoryCountProduct,
  InventoryCountWithProducts,
} from "@/interfaces";
import { isStringEqualCI } from "@/utils";
import { colors, sxFont_18_500 } from "@/theme";

export type InventoryCountWithProductsEditDialogProps = {
  inventoryCountWithProducts?: InventoryCountWithProducts;
  open?: boolean;
  onClose?: (inventoryCountWithProducts?: InventoryCountWithProducts) => void;
};

const columns: GridColDef[] = [
  {
    field: "name",
    headerName: "NAME",
    flex: 1,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "counted",
    headerName: "COUNTED",
    type: "number",
    editable: true,
    flex: 1,
    sortable: false,
    disableColumnMenu: true,
  },
];

export const InventoryCountWithProductsEditDialog: React.FC<
  InventoryCountWithProductsEditDialogProps
> = ({ inventoryCountWithProducts, open = false, onClose }) => {
  const [rows, setRows] = useState<
    InventoryCountWithInventoryCountProduct[] | undefined
  >(inventoryCountWithProducts?.inventoryCountWithInventoryCountProducts);

  const handleClose = (_: any, reason: string) => {
    if (isStringEqualCI(reason, "backdropClick")) {
      return;
    }

    onClose?.();
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={handleClose}>
      <DialogTitle>
        <Typography sx={{ ...sxFont_18_500, textAlign: "center" }}>
          {inventoryCountWithProducts?.productDescription}
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => handleClose(undefined, undefined as unknown as string)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: colors.white,
          backgroundColor: colors.primaryOzone500,
          "&:hover": {
            color: colors.white,
            background: colors.primaryOzone500,
          },
        }}
      >
        <Close />
      </IconButton>
      <DialogContent>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row.inventoryCountProductId}
          hideFooter={true}
          hideFooterPagination={true}
        />
      </DialogContent>
    </Dialog>
  );
};

export default InventoryCountWithProductsEditDialog;
